// extracted by mini-css-extract-plugin
export default {"container":"mobileAppSection_container__9RAFi"};